import './Main.css';
import backgroundVideo from '../assets/video/main.mp4';

export default function Main() {
    return (
        <section className="main">
            <video
                className="main__video"
                autoPlay
                muted
                loop
                playsInline
            >
                <source src={backgroundVideo} type="video/mp4" />
            </video>

            <div className="main__overlay"></div>

            <div className="main__content">
                <h1 className="main__title">
                    СЖИМАЙ
                    <br />
                    ВИДЕО
                    <br />
                    БЫСТРО
                </h1>

                <p className="main__subtitle">
                    Без потери качества. За несколько секунд.
                </p>

                <a href="#compress" className="main__button">
                    Сжать
                </a>
            </div>


        </section>
    );
}